"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var request_1 = require("./utils/request");
var Authenticator = /** @class */ (function () {
    function Authenticator(opts) {
        this.opts = opts;
    }
    Authenticator.prototype.auth = function (channelName, sessionId) {
        var _a = this.opts.onBeforeRequest
            ? this.opts.onBeforeRequest()
            : {}, body = _a.body, headers = _a.headers;
        var payload = {
            sessionId: sessionId,
            channelName: channelName,
            custom: body,
        };
        return request_1.post(this.opts.url, payload, {
            withCredentials: true,
            headers: headers,
        }).then(authSuceess, authFailure);
    };
    return Authenticator;
}());
exports.default = Authenticator;
function authSuceess(_a) {
    var data = _a.data;
    return {
        success: true,
        auth: typeof data === 'object' ? data.token : data,
    };
}
function authFailure(error) {
    var response = error.response;
    return {
        success: false,
        error: {
            status: response ? response.status : -1,
            message: error.toString(),
        },
    };
}
//# sourceMappingURL=authenticator.js.map